// results-main-page.component.ts
import { Component } from '@angular/core';
import { combineLatest, Observable, startWith, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState, Tab } from '../../../../state/app.state';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TabComponent } from '../tab/tab.component';
import { CommonModule } from '@angular/common';
import { selectActiveSideTab, selectActiveTabDetails, selectActiveTabID, selectActiveTabSidenavData, selectMainState, selectSidenavDataByTabIdAndKey, selectTabList } from '../../../../state/selectors';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { PatentViewComponent } from '../patent-view/patent-view.component';
import { Router, RouterOutlet } from '@angular/router';
import { InnovationActivityComponent } from '../result-sections/general/innovation-activity/innovation-activity.component';
import { TechnologyFootprintComponent } from '../result-sections/general/technology-footprint/technology-footprint.component';import { InnovationQualityComponent } from '../result-sections/company-view/innovation-quality/innovation-quality.component';
import { ThematicCompetitionOverviewComponent } from '../result-sections/thematic-view/thematic-competition-overview/thematic-competition-overview.component';

import { ResultsMainHeaderComponent } from '../results-main-header/results-main-header.component';
import { CompanyOverviewComponent } from '../result-sections/company-view/company-overview/company-overview.component';
import { ClusteringInnovationActivityComponent } from '../result-sections/clustering/clustering-innovation-activity/clustering-innovation-activity.component';
import { ClusteringPeerGroupComponent } from '../result-sections/clustering/clustering-peer-group/clustering-peer-group.component';
import { ClusteringTechFootprintComponent } from '../result-sections/clustering/clustering-tech-footprint/clustering-tech-footprint.component';
import { ClusterTreemapComponent } from '../result-sections/clustering/cluster-treemap/cluster-treemap.component';
import { InventionsViewComponent } from '../result-sections/general/inventions-view/inventions-view.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PrivateCompetitorsComponent } from '../result-sections/company-view/private-competitors/private-competitors.component';
import { PublicCompetitorsComponent } from '../result-sections/company-view/public-competitors/public-competitors.component';
import { ThematicPrivateCompetitorsComponent } from '../result-sections/thematic-view/thematic-private-competitors/thematic-private-competitors.component';
import { ThematicPublicCompetitorsComponent } from '../result-sections/thematic-view/thematic-public-competitors/thematic-public-competitors.component';

@Component({
  selector: 'app-results-main-page',
  standalone: true,
  templateUrl: './results-main-page.component.html',
  styleUrls: ['./results-main-page.component.css'],
  imports:[SidebarComponent,TabComponent,CommonModule,MainNavbarComponent,PatentViewComponent,RouterOutlet,InnovationActivityComponent,TechnologyFootprintComponent,InnovationQualityComponent,ThematicCompetitionOverviewComponent,ResultsMainHeaderComponent,CompanyOverviewComponent,ClusteringInnovationActivityComponent, ClusteringPeerGroupComponent,ClusteringTechFootprintComponent,ClusterTreemapComponent, InventionsViewComponent,MatTooltipModule, PrivateCompetitorsComponent, PublicCompetitorsComponent, ThematicPrivateCompetitorsComponent, ThematicPublicCompetitorsComponent]
})
export class ResultsMainPageComponent {

  tabs$!: Observable<Tab[]>;
  activeTab$!:Observable<any>;
  activeSideTab$!:Observable<any>;
  activeTabDetails$!: Observable<Tab | undefined>;
  constructor(private store: Store<AppState>,  private router: Router) {

  }

  ngOnInit(): void {
    this.tabs$ = this.store.select(selectTabList);
    this.activeTab$ = this.store.select(selectActiveTabID);
    this.activeSideTab$ = this.store.select(selectActiveSideTab);
    this.activeTabDetails$ = this.store.select(selectActiveTabDetails);
    this.tabs$.subscribe((tabs) => {
      if (!tabs || tabs.length === 0) {
        this.router.navigate(['/home']); // Navigate to home if tabs are empty
      }
    });
  }

  getParams() {
    return this.activeTabDetails$; // returns an observable that can be used in the template
  }

  showQueryBox = false;

toggleQueryBox() {
  this.showQueryBox = !this.showQueryBox;
}

}
